// Footer.js
import React, { useEffect, useState } from "react";
import "./footer.css";
import logo from "../../../assets/images/skyeairLogoSvg.svg";
import logo1 from "../../../assets/images/facebook.png";
import logo2 from "../../../assets/images/instagram.png";
import logo3 from "../../../assets/images/twitter1.png";
import logo4 from "../../../assets/images/linkedin.png";
import { Link } from "react-router-dom";
import ScrollLink from "../../../Utils/ScrollToTop";
import useGetdata from "../../../Hooks/useGetData";
import { useSelector } from "react-redux";
import location from "../../../assets/images/location.svg";
import phone from "../../../assets/images/phone.svg";
import email from "../../../assets/images/mail.svg";

const Footer = () => {
  const FooterData = useSelector((store) => store.data.HomeData);
  // console.log(FooterData);

  const [data, setData] = useState(null);
  useEffect(() => {
    FooterData?.items.forEach((ele) => {
      if (ele.Section == "Footer") {
        setData(ele);
      }
    });
  }, [FooterData]);
  // const queriesContact = [
  //   {
  //     header: 'Sales Queries',
  //     name: 'Joey Tribbnai',
  //     phone: 8767876567,
  //     email: 'sales@skyeair.tech'
  //   },
  //   {
  //     header: 'Sales Queries',
  //     name: 'Joey Tribbnai',
  //     phone: 8767876567,
  //     email: 'sales@skyeair.tech'
  //   },
  //   {
  //     header: 'Sales Queries',
  //     name: 'Joey Tribbnai',
  //     phone: 8767876567,
  //     email: 'sales@skyeair.tech'
  //   },
  //   {
  //     header: 'Sales Queries',
  //     name: 'Joey Tribbnai',
  //     phone: 8767876567,
  //     email: 'sales@skyeair.tech'
  //   }
  // ]
  return (
    <footer>
      <div className="footer">
        <div className="footer-section description">
          <ScrollLink to="/home" className="p-left">
            <img
              src={logo}
              alt="Logo"
              className="footer-logo-icon"
              height={50}
            />
          </ScrollLink>
          <br></br>
          <br></br>
          <p>
            Transforming how the world moves with drone-powered, sustainable
            drone delivery solutions!
          </p>
          <br></br>
          CIN: U63030HR2022PTC104123
        </div>

        <div className="footer-section links">
          <h5>Company</h5>
          <ul>
            <li>
              <ScrollLink to="/solutions">Solutions</ScrollLink>
            </li>
            <li>
              <ScrollLink to="/about">About Skye Air</ScrollLink>
            </li>
            <li>
              <ScrollLink to="/media">Media & Partners</ScrollLink>
            </li>
            <li>
              <ScrollLink to="/contact">Contact Us</ScrollLink>
            </li>
          </ul>
        </div>

        <div className="footer-section contact-info">
          <h5>Office Address</h5>
          <div className="contact-details-section contact-info address-footer">
            <div class="d-flex ">
              <img src={location} height={17} className="mt-3 me-3" />
              <p> {data?.Content.OfficeAddress}</p>
            </div>
            <div class="d-flex ">
              <img src={email} height={12} className="mt-3 me-3" />
              <p> {data?.Content?.OfficeEmail}</p>
            </div>
            { data?.Content?.OfficeContact?.trim() && (
              <div className="d-flex">
                <img src={phone} height={14} className="mt-3 me-3 ms-1" />
                <p>{data?.Content?.OfficeContact}</p>
              </div>
            )}
          </div>
        </div>

        <div className="footer-queries-section">
          {data?.Content?.Contacts?.map((item, index) => (
            <div className="footer-queries" key={index}>
              <h5>{item.Department}</h5>
              <p>{item.Name}</p>
              <p>{item.Email}</p>
              <p>{item.Number}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        {/* <hr></hr> */}
        <div>©2025 Skye Air Mobility Pvt Ltd - All Rights Reserved</div>
        <div className="terms-section mobile">
          <span onClick={() =>window.open(data?.Content?.PrivacyPolicy, "_blank")}> Privacy Policy</span>
          <span className="ms-5"  onClick={() => window.open(data?.Content?.CompanyInfo, "_blank")}> Corporate Info</span>
        </div>
        <div>
          <span
            className="me-2 font-small non-mobile"
            style={{ cursor: "pointer" }}
            onClick={() =>window.open(data?.Content?.PrivacyPolicy, "_blank")}
          >
            Privacy Policy
          </span>

          <span
            className="me-1 font-small non-mobile"
            style={{ cursor: "pointer" }}
            onClick={() => window.open(data?.Content?.CompanyInfo, "_blank")}
          >
            Corporate Info
          </span>

          <a
            href="https://www.facebook.com/OfficialSkyeAirMobility/"
            target="_blank"
          >
            <img src={logo1} alt="Logo" className="footer-logo" height={25} />
          </a>
          <a href="https://www.instagram.com/skyeairofficial/" target="_blank">
            <img src={logo2} alt="Logo" className="footer-logo" height={25} />
          </a>
          <a href="https://x.com/air_skye" target="_blank">
            <img src={logo3} alt="Logo" className="footer-logo" height={25} />
          </a>
          <a
            href="https://in.linkedin.com/company/skyeairmobility"
            target="_blank"
          >
            <img src={logo4} alt="Logo" className="footer-logo" height={25} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
